export default __webpack_public_path__ + "static/media/file-image-o-dark.b00506fa.svg";